import React, {Component} from 'react';
import {NavLink} from 'components/ReactRouterDomLocalized';

import BlackListForm from './BlackListForm';

import paths from 'paths';

import '../../../sass/headers/header.scss';

import {t, dt} from 'l10n';

class HeaderBlackList extends Component {

    render() {
        let {title} = this.props;

        return (
            <header className="blackList-header">
                <div className="content">
                    <h1>{title}</h1>
                    <div className="text-blackList-header">
                        {<BlackListForm/>}
                        <div className="blackList-desc">
                            {t('If you add a nick to your black list, that user will no longer send you any message on site.')} <br />
                            {t('If you are My BobTV room creator, that user will not be able to stay in your room.')} <br />
                            {t('The number of permanently blocked users is limited to 20 users.')} <br />
                            {t('Do not block without reason!')}
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderBlackList;


// WEBPACK FOOTER //
// ./src/containers/member/blackList/HeaderBlackList.js